// extracted by mini-css-extract-plugin
module.exports = {"root":"EventWrapper_root__Yc8yu","noInteraction":"EventWrapper_noInteraction__2WdJe","pointerPassthrough":"EventWrapper_pointerPassthrough__PAY5V"};